var map = {
	"./flag-bg.png": "DiMT",
	"./flag-de.png": "qmSN",
	"./flag-el.png": "szNy",
	"./flag-en.png": "M9uk",
	"./flag-es.png": "leRv",
	"./flag-fr.png": "Y9V5",
	"./flag-it.png": "ElP0",
	"./flag-pl.png": "qtAf",
	"./flag-ru.png": "90VK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yqx3";